module.exports = __webpack_public_path__ + "static/img/head-en.bc5f7565.png";